import styled from '@emotion/styled';

import { getColor } from '../../common/UICommon';

import { TabletWidth } from '../../../global.style';
import { ContentBox } from '../../common/v2/Box/Box.style';

export const PaymentSecurityContentBox = styled(ContentBox)``;

export const PaymentSecurityBoxContainer = styled.div`
  display: flex;
  gap: 12px;

  @media (max-width: ${TabletWidth}px) {
    margin-top: 0px;
    flex-direction: column;
  }
`;

export const PaymentSecurityBoxRow = styled.div<{ isLast?: boolean }>`
  margin-bottom: ${({ isLast }) => (isLast ? 0 : 16)}px;
  display: flex;
  align-items: center;
`;

export const PaymentSecurityItem = styled.div`
  display: flex;
  border: 1px solid ${getColor('GRAY_30')};
  border-radius: 8px;
  align-items: center;
  width: 50%;

  @media (max-width: ${TabletWidth}px) {
    width: 100%;
  }
`;

export const PaymentSecurityItemIconCol = styled.div`
  padding: 8px;
`;

export const PaymentSecurityItemIcon = styled.img`
  width: 40px;
  height: 40px;
`;

export const PaymentSecurityItemContentCol = styled.div`
  border-left: 1px solid ${getColor('GRAY_30')};
  padding: 12px;
`;
export const PaymentSecurityItemTitle = styled.p`
  color: ${getColor('PURPLE_60')};
  font-size: 14px;
  font-weight: 600;
`;
export const PaymentSecurityItemText = styled.p`
  font-size: 12px;
  font-weight: 400;
`;
